import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import './registerServiceWorker'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import store from './store'
document.title = "Web Point of Sale";

const app = createApp(App)

Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  enabled: process.env.NODE_ENV === 'production',
})

app.config.globalProperties.$t = (key) => key
app.use(store).use(router).mount('#app')
